/* eslint-disable */
import SitecoreModeService from '../../services/sitecore-mode-service'

const SitecoreExpEditorPlugin = {
  install: function(Vue, options) {
    if (SitecoreModeService.IsExperienceEditor()) {
      Sitecore.PageModes.ChromeTypes.Placeholder = Sitecore.PageModes.ChromeTypes.Placeholder.extend({
        _frameLoaded: function (response) {
          var parser = new DOMParser()
          var doc = parser.parseFromString(response, "text/html")
          var renderingUniqueId = $sc.parseQuery(this._frameLoadedUrl)["sc_ruid"]
  
          var renderingDomElement = doc.getElementById("r_" + renderingUniqueId)

          const getElementFromTemplateList = (templateList, uniqueid) => {
            if (templateList.length <= 0) {
              return null
            }
            let element = null
            templateList.forEach(t => {
              element = element || t.content.querySelector("#r_" + uniqueid)
              if (!element) {
                element = getElementFromTemplateList(t.content.querySelectorAll('template'), uniqueid)
              }
            })
            return element
          }
          if (!renderingDomElement) {
            renderingDomElement = getElementFromTemplateList(doc.querySelectorAll('template'), renderingUniqueId)
          }
  
          var callbackData = new Object()
  
          if (renderingDomElement != null) {
              var start = $sc(renderingDomElement)
  
              if (!start.is("code[type='text/sitecore'][chromeType='rendering'][kind='open']")) {
                  throw "Loaded unexpected element while trying to get rendering html from server. Expected opening script marker."
              }
  
              var middle = this._getRenderingContent(start, "code[type='text/sitecore'][chromeType='rendering'][kind='close']")
              var end = middle.length > 0 ?
                  $sc(middle.last()[0].nextSibling) :
                  start.last().next()
  
              start = start.clone()
              middle = middle.clone()
              end = end.clone();
              var elements = start.add(middle).add(end)
  
              if (!elements.last().is("code[type='text/sitecore'][chromeType='rendering'][kind='close']")) {
                  console.error(elements);
  
                  throw "Loaded unexpected element while trying to get rendering html from server. Expecting last tag to be closing script marker"
              }
  
              callbackData.renderingElement = { opening: start, content: middle, closing: end, combined: elements }
              var scLayout = doc.getElementById("scLayout")
              if (scLayout) {
                  Sitecore.LayoutDefinition.setLayoutDefinition(scLayout.textContent)
              } else {                
                  var scriptTags = doc.querySelectorAll("script[data-mode='onPageEditingOfComposites']")
                  for (var i = 0; i < scriptTags.length; i++) {
                      var script = scriptTags.item(i)
                      eval(script.text)
                  }
              }
          }
          else {
              console.error("Could not find the rendering in the HTML loaded from server")
  
              if (this._frameLoadedUrl.toLowerCase().indexOf("pagedesignererror.aspx") > -1) {
                  callbackData.error = Sitecore.PageModes.Texts.SublayoutWasInsertedIntoItself
              }
              else {
                  callbackData.error = Sitecore.PageModes.Texts.ErrorOcurred
              }
          }
  
          if (this._frameLoadedCallback != null) {
              this._frameLoadedCallback(callbackData)
              this._frameLoadedCallback = null
          }
      },
      }, 
      {
        emptyLookFillerCssClass: Sitecore.PageModes.ChromeTypes.Placeholder.emptyLookFillerCssClass,
        getDefaultAjaxOptions: Sitecore.PageModes.ChromeTypes.Placeholder.getDefaultAjaxOptions
      });
    }
  }
}


export default SitecoreExpEditorPlugin